/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsgroupaccess2Inputs */

const en_settingsgroupaccess2 = /** @type {(inputs: Settingsgroupaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility and access`)
};

const de_settingsgroupaccess2 = /** @type {(inputs: Settingsgroupaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeit und Zugang`)
};

/**
* | output |
* | --- |
* | "Visibility and access" |
*
* @param {Settingsgroupaccess2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const settingsgroupaccess2 = /** @type {((inputs?: Settingsgroupaccess2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsgroupaccess2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settingsgroupaccess2(inputs)
	return de_settingsgroupaccess2(inputs)
});
export { settingsgroupaccess2 as "settingsGroupAccess" }